import Expenses from './Expenses';
import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/expenses';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.expense,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Expenses);
